import VideoConference from './VideoConference';
export default VideoConference;
